<template>
  <div>
    <ModuleHeader>Reporte Actividades</ModuleHeader>
    <v-row>
      <v-col md="12" cols="12">
        <v-card>
          <v-card-text>
            <p class="text-subtitle-1">Filtros</p>
            <v-row>
              <v-col md="4" cols="12" class="input">
                <label>Fecha inicial</label>
                <Datepicker
                  @selected="selectDate"
                  :value="input_date.format('MM/DD/YYYY')"
                ></Datepicker>
              </v-col>
              <v-col md="4" cols="12" class="input">
                <label>Fecha final</label>
                <Datepicker
                  @selected="selectDateFinal"
                  :disabled-dates="disableDates"
                  :value="input_date_final.format('MM/DD/YYYY')"
                ></Datepicker>
              </v-col>
              <v-col md="4" cols="12">
                <v-autocomplete
                  label="Actividad"
                  v-model="rvaDepto"
                  item-text="nm"
                  item-value="id"
                  :items="actividades"
                ></v-autocomplete>
              </v-col>

              <v-col md="4" cols="12">
                <v-select
                  label="Estatus"
                  v-model="statusFilter"
                  :items="compStatus"
                  item-text="Nombre"
                  item-value="id"
                >
                </v-select>
              </v-col>
              <v-col md="12" cols="12">
                <v-btn @click="getReservas()" color="green" dark>
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12" cols="12">
        <v-alert outlined color="primary">
          <div class="text-h6">
            Estadistica
          </div>
          <div>
            <v-row>
              <v-col md="2" cols="12">
                <h3>Reservas : {{ reservas_comp.length }}</h3>
              </v-col>
              <v-col md="2" cols="12">
                <h3>Jugadores : {{ totalPlayers }}</h3>
              </v-col>
              <v-col md="2" cols="12">
                <h3>Pagados: {{ totalPagados }}</h3>
              </v-col>
              <v-col md="2" cols="12">
                <h3>Pendientes: {{ totalPlayers - totalPagados }}</h3>
              </v-col>
              <v-col md="2" cols="12">
                <h3>Cancelados: {{ totalCancelados }}</h3>
              </v-col>
            </v-row>
          </div>
        </v-alert>
      </v-col>

      <v-col md="12" cols="12">
        <v-row>
          <v-col md="4"> Resultados: </v-col>

          <v-col md="8" class="text-right">
            <v-btn v-if="false" @click="prePrintPdf = true" color="red" dark
              ><v-icon>mdi-file-pdf</v-icon>

              Generar PDF
            </v-btn>
            <v-btn color="green" dark @click="exportExcel()"
              ><v-icon>mdi-file-excel-box</v-icon>
              Exportar a Excel
              <!-- <download-excel
                type="xls"
                name="Reporte reservas"
                :data="reservas_comp"
                :fields="json_fields"
              >
              </download-excel> -->
            </v-btn>
          </v-col>
        </v-row>
        <v-simple-table>
          <thead>
            <tr>
              <th>Folio</th>
              <th>Cliente</th>
              <th>Creacion</th>
              <th>Salida</th>
              <th>Fecha</th>
              <th>Hora</th>
              <th>Duracion</th>
              <th>Fecha final</th>
              <th>Hora Final</th>
              <th>Estatus</th>
              <th>Folio Venta</th>
              <th>Notas</th>
              <th>Total</th>
              <th>Moneda</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="reservations.length == 0">
              <td colspan="7">No se encontraron datos</td>
            </tr>
            <template v-for="(res, index) in reservas_comp">
              <tr :key="index">
                <td>{{ res.fl }}</td>
                <td>{{ res.cl.al }}</td>
                <td>{{ res.fechaCreacion.format("DD-MM-YYYY") }} <br/> {{res.Creador}}</td>
                <td>{{ res.bh.nm }}</td>
                <td>{{ res.format_date.format("DD-MM-YYYY") }}</td>
                <td>{{ res.format_date.format("HH:mm") }}</td>
                <td>{{ res.dc }} min.</td>
                <td>{{res.format_fecha_final}}</td>
                <td>{{ res.format_date_final.format("HH:mm") }}</td>
                <td>
                  <b v-if="res.et == 'R'" class="primary--text"
                    >Confimado</b
                  >
                  <b v-else-if="res.et == 'C'" class="red--text"
                    >Cancelado</b
                  >
                  <b v-else-if="res.et == 'N'" class="greey--text">{{
                    res.et
                  }}</b>
                  <b v-else-if="res.et == 'P'" class="green--text"
                    >Pagado</b
                  >
                  <b v-else
                    >{{ res.et }}
                  </b>
                </td>

                <td>{{ res.fv }}</td>
                <td>{{ res.nt}}</td>
                <td>${{ res.tt.C }}</td>
                <td>{{ res.tt.M }}</td>
                <td>
                  <v-btn @click="selectRes(res)" color="success"
                    >Bitacora</v-btn
                  >
                </td>
              </tr>
            </template>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-dialog v-model="prePrintPdf" max-width="850">
      <v-card>
        <v-card-title class="text-h5">
          Generar PDF
        </v-card-title>
        <v-card-text>Seleccione una opción </v-card-text>
        <v-card-text>
          <v-row>
            <v-col @click="generatePdfConcierges()" md="4">
              <v-btn color="red" dark>
                <v-icon>mdi-file-pdf</v-icon>
                Detalle por concierge
              </v-btn>
            </v-col>
            <v-col md="4">
              <v-btn @click="generatePdfDetailed()" color="red" dark>
                <v-icon>mdi-file-pdf</v-icon>
                Detalle por Agencia
              </v-btn>
            </v-col>
            <v-col @click="generatePdf()" md="4">
              <v-btn @click="prePrintPdf = true" color="red" dark>
                <v-icon>mdi-file-pdf</v-icon>
                Todas las Reservas
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="prePrintPdf = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bitacoraToogle" max-width="850">
      <v-card>
        <v-card-title class="text-h5">
          Bitacora de cambios de la reserva {{ selectedRes.fl }}
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item v-for="(reg, index) in selectedRes._c" :key="index">
              <v-list-item-content>
                <v-card class="mx-4">
                  <v-card-text>
                    <b>Informacion de cambio</b><br />
                    <b>{{reg.c.m}}</b><br />
                    <b>Realizado por:</b>{{ reg.u.n }}<br />
                    <b>Fecha:</b>{{ formatDate(reg.t) }}<br />
                    <ul>
                     
                        <li>
                          <b>{{reg.c.m}}</b>
                        </li>

                        <div class="mb-8">
                          <div class="my-4">Antes : {{ reg.c.d.a}}</div>
                          <div class="my-4">Despues:{{ reg.c.d.d }}</div>
                        </div>
                    </ul>
                  </v-card-text>
                </v-card>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Cliente from "../../../clases/Cliente.js";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import RepoReservas from "../../../clases/PdfMakers/RepoReservas";
import RepoReservasAfiliado from "../../../clases/PdfMakers/RepoReservasAfiliado";
import RepoReservasConcierge from "../../../clases/PdfMakers/ReporteReservasConcierge.js";
import TarifasClass from "../../../clases/Tarifa.js";
import GenericExcelExporter from "../../../clases/ExcelMaker/GeneralExcel.js";
export default {
  name: "ReporteActividades",
  components: {
    Datepicker,
  },
  props: [],
  data() {
    return {
      actividades: [],
      rvaDepto: "ALL",
      selectedRes: {},
      TarifarioFilter: "ALL",
      afiliado: false,
      concierge: false,
      selectedConcierge: "All",
      prePrintPdf: false,
      clienteFilter: "All",
      statusFilter: "All",
      loadingData: false,
      showEstad: false,
      input_date: moment(),
      input_date_final: moment(),
      showModal: false,
      bitacoraToogle: false,
      MainDepartamento: "",
      formKey: 0,
      selectedHotel: "",
      hoteles: [],
      concierges: [],
      Horario: "",
      Horarios: [],
      reservations: [],
      status: [],
      tarifarios: [],
    };
  },
  methods: {
    exportExcel() {
      const options = {
        json_fields: this.json_fields
      }
     GenericExcelExporter.generateExcelBuffer(this.reservas_comp, options)
       .then(buffer => {
         const blob = new Blob([buffer], {
           type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
         });
         const url = window.URL.createObjectURL(blob);
         const link = document.createElement('a');
         link.href = url;
         link.download = "Reporte reservas.xlsx";
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
         window.URL.revokeObjectURL(url);
       })
       .catch(err => console.error("Error exportando Excel:", err));
   },
    selectRes(data) {
      this.bitacoraToogle = true;
      this.selectedRes = data;
    },
    async getConcierges() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Concierge"
      );
      if (!data.exists()) {
        return false;
      }
      let concierges = Object.entries(data.val());
      let conciergesData = [{ id: "All", nom: "Todos" }];
      concierges.forEach(function(element) {
        conciergesData.push({
          id: element[0],
          ...element[1],
        });
      });
      this.concierges = conciergesData;
    },
    async getComboTarifarios() {
      /* obtiene el listado de tarifas para armado del comboBox */
      let tarifarios = await TarifasClass.getMixTarifasCombo("Golf");
      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      this.tarifarios = tarifarios;
    },
    formatDate(timestamp) {
      let d = new Date(timestamp);
      //
      //let Creacion =   d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
      return new moment(d).format("DD-MM-YYYY HH:mm");
    },
    generatePdf() {
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),

        TITLE: "Reservas",
        data: this.reservas_comp,
      };
      let docData = RepoReservas.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    generatePdfDetailed() {
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),

        TITLE: "Reservas Agencia",
        data: this.reservas_comp,
      };
      let docData = RepoReservasAfiliado.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    generatePdfConcierges() {
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),

        TITLE: "Reservas Concierge",
        data: this.reservas_comp,
      };
      let docData = RepoReservasConcierge.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getReservas() {
      this.loadingData = true;
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filters = [
        firestore.where("fi", ">=", startDate),
        firestore.where("fi", "<", end),
        firestore.where(
          "tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ];

      console.log(this.rvaDepto)
      if (this.rvaDepto != "ALL") {
        filters.push(firestore.where("ac.id", "==", this.rvaDepto));
      }

      const data = await firestore.queryBuilder("ACT_Reservas", filters);

      this.reservations = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      
      this.showEstad = true;
      this.loadingData = false;
    },
    async getActividades() {
      let actividades = [{id:"ALL",nm:"TODAS"}];
      const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "ACT/Actividades"
      );
      if (snapshot.val()) {
        let docs = Object.entries(snapshot.val());
        docs.forEach((element) => {
          actividades.push({ id: element[0], ...element[1] });
        });
        this.actividades = actividades;
      } else {
        this.actividades = [];
      }
    },
  },
  computed: {
    compStatus() {
      let arrayStatus = [
        { id: "All", Nombre: "Todos" },
        { id: "P", Nombre: "Pagado" },
        { id: "C", Nombre: "Cancelado" },
        { id: "R", Nombre: "Reserva Confirmada" },
      ];
      let status = [];
      if (this.status) {
        status = Object.keys(this.status);
      }
      status.forEach((element, index) => {
        let selected = false;
        let totalRes = 0;
        arrayStatus.push({
          id: element,
          Nombre: element,
          cantidad: totalRes,
          selected: selected,
        });
      });

      return arrayStatus;
    },
    json_fields() {
      let ObjTitle = {
        Folio: "fl",
        Creador: "Creador",
        Cliente: "Cliente",
        Salida:"bh.nm",
        //Jugadores: "totalAccount",
        Fecha: "format_fi",
        Duracion:"dc",
        Inicio: "format_horainicial",
        Termino: "format_horafinal",
        Estatus: "et",
        FolioVenta: "fv",
        Notas: "nt",
        Total: "tt.C",
        Moneda: "tt.M",
      };
      return ObjTitle;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    reservas_comp() {
      let res = [];
      this.reservations.forEach((ele) => {
        ele.format_date= moment(ele.fi, "YYYY-MM-DD_HH:mm:ss"),
        ele.format_fi =ele.format_date.format("DD-MM-YYYY")
        ele.format_horainicial =ele.format_date.format("HH:mm")
        ele.format_date_final = moment(ele.ft, "YYYY-MM-DD_HH:mm:ss")
        ele.format_fecha_final = ele.format_date_final.format("YYYY-MM-DD")
        ele.format_horafinal = ele.format_date_final.format("HH:mm")
        ele.fechaCreacion =  moment(ele._m.ca.t)
        ele.Creador = ele._m.ca.u.n
        ele.Cliente = ele.cl.al
        res.push(ele)        
      });
      return this.$_.orderBy(res, ["fi", "fl"], "desc");
    },
    total() {
      let total = 0;
      this.reservations.forEach((ele) => {
        total = total + ele.Totales.USD;
      });
      var formatter = new Intl.NumberFormat("en-US");

      return formatter.format(total);
    },
    golfClub() {
      let golf = 0;
      this.reservations.forEach((ele) => {
        let index = this.$_.findIndex(ele.Addons, ["Id", "GolfClub"]);
        if (index >= 0) {
          golf = golf + ele.Addons[index].Cantidad;
        }
      });
      return golf;
    },
    extraRider() {
      let golf = 0;
      this.reservations.forEach((ele) => {
        let index = this.$_.findIndex(ele.Addons, ["Id", "ExtraRidder"]);
        if (index >= 0) {
          golf = golf + ele.Addons[index].Cantidad;
        }
      });
      return golf;
    },
    totalPlayers() {
      let golf = 0;
      this.reservas_comp.forEach((ele) => {
        if (ele.et !== "C") {
          golf++;
        }
      });
      return golf;
    },
    totalPagados() {
      let golf = 0;
      this.reservas_comp.forEach((ele) => {
        if (ele.et === "P") {
          golf ++;
        }
      });
      return golf;
    },
    totalCancelados() {
      let golf = 0;
      this.reservas_comp.forEach((ele) => {
        if (ele.et == "C") {
          golf++;
        }
      });
      return golf;
    },
    comp_clients() {
      let clientes = [{ value: "All", text: "Todos" }];
      let rowclientes = this.$pgsHelper.indexBy(Cliente.getClientsList(), "Id");
      rowclientes.forEach((cli) => {
        clientes.push({ value: cli.Id, text: cli.getNombreCompleto(), ...cli });
      });
      return clientes;
    },
    departamentos() {
      let deptos = [{ text: "Todos", value: "ALL" }];
      let departamentos = this.$store.getters.getDepartamentos;
      departamentos.forEach((dep) => {
        (dep.text = dep.Nombre), (dep.value = dep.id);
        deptos.push(dep);
      });
      return deptos;
    },
  },
  watch: {},
  mounted() {
    this.getActividades();
  },
  created() {
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
